import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromProtection from '../actions/protection.action';
import { tap, withLatestFrom } from 'rxjs/operators';
import { FormStep } from '@dgx-pr-spa/shared/util';

@Injectable()
export class ProtectionEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly completeOrderService: CompleteOrderService
  ) {}

  protection$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromProtection.resetProtection, fromProtection.addProtection),
        withLatestFrom(this.completeOrderService.formData$),
        tap(([, form]) => {
          this.completeOrderService.updateActiveFormStep(FormStep.Delivery);
          this.completeOrderService.resetDirectDebitValidation();
          this.completeOrderService.resetDirectDebitForm(form);
        })
      ),
    { dispatch: false }
  );
}
